import { EthProvider } from 'context/eth.context';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ROUTES } from 'routes';
import { AuthProvider } from './context/auth.context';
import Onboarding from './components/onboarding/OnboardingStep1';
// import UiPlayground from 'components/BionicUI/UiPlayground';
import ApplicationInReview from 'components/onboarding/in-review/ApplicationInReview';
// import Dashboard from 'components/dashboard/Dashboard';
// import Project from 'components/project/Project';
// import OnboardingKYC from 'components/onboarding/OnboardingKYC';
import OnboardingProject from 'components/onboarding/OnboardingProject';
// import OnboardingNFT from 'components/onboarding/OnboardingNFT';
import ToastManager from 'components/BionicUI/toast/ToastManager';
// import Profile from 'components/profile/Profile';
import ProtectedRoutes from 'components/auth/ProtectedRoute';
import Login from 'components/auth/login/Login';
// import KYCResult from 'components/onboarding/kyc/KYCResult';
import Landing from 'components/auth/Landing';
// import GeoBlock from 'components/geo-block/GeoBlock';
import { initSentry, ErrorBoundary } from 'components/sentry';
import { NotifyProvider } from 'context/notify.context';
import { PrivyProvider } from '@privy-io/react-auth';
import { base } from 'viem/chains';
import WalletProvider from 'components/provider/WalletProvider';
import { Analytics } from '@vercel/analytics/react';

export const privyAppId = 'cmfme7m2100rwjy0bull7q7ky';

function App() {
  initSentry();

  return (
    <PrivyProvider
      appId={privyAppId}
      config={{
        // Configures email, wallet, Google, Apple, and Farcaster login
        // loginMethods: ['wallet'],
        defaultChain: base,
        supportedChains: [base],
        // embeddedWallets: {
        //   createOnLogin: 'users-without-wallets', // defaults to 'off'
        // },
        appearance: {
          theme: 'dark', // dark theme
          accentColor: '#ffffff',
          showWalletLoginFirst: false,
        },
      }}
    >
      <WalletProvider>
        <ErrorBoundary>
          <NotifyProvider>
            <AuthProvider>
              <EthProvider>
                <Analytics />
                <Routes>
                  <Route path="/" element={<Navigate to={ROUTES.LANDING} />} />
                  <Route path={ROUTES.LANDING} element={<Landing />} />
                  <Route path={ROUTES.LOGIN} element={<Login />} />
                  {/* <Route
                    path={ROUTES.ONBOARDING_NFT}
                    element={<ProtectedRoutes component={OnboardingNFT} />}
                  />
                  <Route
                    path={ROUTES.ONBOARDING_KYC_RESULT}
                    element={<ProtectedRoutes component={KYCResult} />}
                  />
                  <Route
                    path={ROUTES.ONBOARDING_KYC}
                    element={<ProtectedRoutes component={OnboardingKYC} />}
                  /> */}
                  <Route path={ROUTES.ONBOARDING} element={<Onboarding />} />
                  <Route
                    path={ROUTES.ONBOARDING_PROJECT}
                    element={<ProtectedRoutes component={OnboardingProject} />}
                  />
                  {/* <Route
                    path={ROUTES.PROFILE}
                    element={<ProtectedRoutes component={Profile} />}
                  />
                  <Route
                    path={ROUTES.DASHBOARD}
                    element={<ProtectedRoutes component={Dashboard} />}
                  /> */}
                  {/* <Route
                    path={ROUTES.PROJECT}
                    element={<ProtectedRoutes component={Project} />}
                  /> */}
                  <Route
                    path={ROUTES.APPLICATION_IN_REVIEW}
                    element={
                      <ProtectedRoutes component={ApplicationInReview} />
                    }
                  />
                  {/* <Route
                    path={ROUTES.UIPLAYGROUND}
                    element={<UiPlayground />}
                  /> */}
                </Routes>
                <ToastManager />
              </EthProvider>
            </AuthProvider>
          </NotifyProvider>
        </ErrorBoundary>
      </WalletProvider>
      <Routes>
        {/* <Route path={ROUTES.GEO_BLOCK} element={<GeoBlock />} /> */}
      </Routes>
    </PrivyProvider>
  );
}

export default App;
